import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo-header.png";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const closeSidebar = () => setIsOpen(false);

  return (
    <>
      <nav style={styles.navbar}>
        <div style={styles.container}>
          {/* Logo */}
          <div
            style={styles.logoWrapper}
            onClick={() => (window.location.href = "/home")}
          >
            <img src={logo} alt="Logo" style={styles.logo} />
          </div>

          {/* Tagline */}
          <span className="w3-hide" style={styles.tagline}>
            Innovation • Integrity • Impact
          </span>

          {/* Inline nav links */}
          <ul className="w3-hide" style={styles.navLinks}>
            <li>
              <NavLink to="/home" style={styles.link}>Home</NavLink>
            </li>
            <li>
              <NavLink to="/services" style={styles.link}>What we do</NavLink>
            </li>
            <li>
              <NavLink to="/aboutus" style={styles.link}>Who we are</NavLink>
            </li>
          </ul>

          {/* Hamburger Icon (mobile only) */}
          <div style={styles.menuIcon} onClick={toggleSidebar}>
            <div style={styles.bar}></div>
            <div style={styles.bar}></div>
            <div style={styles.bar}></div>
          </div>
        </div>
      </nav>

      {/* Sidebar for mobile */}
      {isOpen && (
        <>
          <div
            style={styles.sidebar}
          >
            <button onClick={closeSidebar} style={styles.closeBtn}>✕</button>
            <NavLink to="/home" onClick={closeSidebar} style={styles.sidebarLink}>Home</NavLink>
            <NavLink to="/services" onClick={closeSidebar} style={styles.sidebarLink}>What we do</NavLink>
            <NavLink to="/aboutus" onClick={closeSidebar} style={styles.sidebarLink}>Who we are</NavLink>
            <NavLink to="/projects" onClick={closeSidebar} style={styles.sidebarLink}>Projects</NavLink>
            <NavLink to="/workwithus" onClick={closeSidebar} style={styles.sidebarLink}>Work With Us</NavLink>
            <NavLink to="/partners" onClick={closeSidebar} style={styles.sidebarLink}>Partners</NavLink>
            <NavLink to="/contact" onClick={closeSidebar} style={styles.sidebarLink}>Get in touch</NavLink>
          </div>
          <div style={styles.overlay} onClick={closeSidebar}></div>
        </>
      )}
    </>
  );
}

const styles = {
  navbar: {
    backgroundColor: "#fff",
    color: "#fff",
    padding: "20px 10px",
    textAlign: "center",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  },
  logoWrapper: {
    cursor: "pointer",
  },
  logo: {
    height: "40px",
    marginBottom: "10px",
  },
  tagline: {
    fontSize: "14px",
    marginBottom: "15px",
    fontWeight: "500",
  },
  navLinks: {
    listStyle: "none",
    display: "flex",
    gap: "20px",
    padding: 0,
    margin: "0 0 15px 0",
  },
  link: {
    color: "#fff",
    textDecoration: "none",
    fontSize: "14px",
  },
  menuIcon: {
    display: "none", // hidden on desktop
    position: "absolute",
    right: "10px",
    top: "20px",
    cursor: "pointer",
  },
  bar: {
    width: "25px",
    height: "3px",
    backgroundColor: "#fff",
    margin: "4px 0",
  },
  // Sidebar styles
  sidebar: {
    width: "250px",
    backgroundColor: "#000",
    position: "fixed",
    right: 0,
    top: 0,
    height: "100%",
    zIndex: 1201,
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  closeBtn: {
    alignSelf: "flex-end",
    background: "none",
    border: "none",
    color: "#fff",
    fontSize: "20px",
    cursor: "pointer",
  },
  sidebarLink: {
    color: "#fff",
    textDecoration: "none",
    fontSize: "16px",
    padding: "8px 0",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.4)",
    zIndex: 1200,
  },
};

export default Navbar;
